import { api } from '@/api/client';
import { normalizeVideo } from '@/api/normalize/video';
import type {
  BookmarksResponse,
  BookmarkTitleResponse,
  RawVideoReference,
  VideoReference,
} from '@/api/types';

/** Saved поверх служебной доски «Saved» на бэкенде (canvas-spec.md §8.1); mock — тот же контракт. */
export const bookmarksApi = {
  list: () => api.get<BookmarksResponse>('/bookmarks'),
  /**
   * Сами видео закладок для страницы Saved — в форме каталога. Ответ проходит
   * ту же нормализацию, что и выдача: бэкенд отдаёт `saved_board_ids`, а
   * страница читает `saved_canvas_ids` (BookmarkController::videos).
   */
  videos: async (): Promise<{ data: VideoReference[] }> => {
    const response = await api.get<{ data: RawVideoReference[] }>('/bookmarks/videos');
    return { ...response, data: response.data.map(normalizeVideo) };
  },
  add: (videoId: number, searchEventId?: number | null) =>
    api.post<BookmarksResponse>(
      '/bookmarks',
      { video_reference_id: videoId },
      searchEventId ? { headers: { 'X-Search-Event-Id': String(searchEventId) } } : undefined,
    ),
  remove: (videoId: number) => api.delete<BookmarksResponse>(`/bookmarks/${videoId}`),
  /** Своё название закладки; null — вернуть название видео. Закладки нет — 404. */
  setTitle: (videoId: number, title: string | null) =>
    api.patch<BookmarkTitleResponse>(`/bookmarks/${videoId}`, { title }),
};
